//@flow
import {
    bulkOutletFetch,
    zoneMapCreate as zoneMapCreateApi,
    homebase as homebaseApi,
    outletAutosortApi
} from 'common/middleware/api';

import type { Dispatch } from 'redux';
import { showToast } from 'common/redux/actions/toast';
import { ToastTypes } from 'common/components/core/toast/Toast';
import FilterListBuilder from 'common/models/helpers/FilterListBuilder';
import type { ZoneMap } from 'common/models/internal/ZoneMap';
import type { MasterOutlet } from 'common/models/internal/MasterOutlet';
import type { MasterHomebase } from 'common/models/internal/MasterHomebase';

type TerritoryOutlets = {
    outlets: Array<MasterOutlet>,
    pagination: {
        total: number,
        numberOfPages: number,
        currentPage: number
    }
};
export default class TerritoryPlanningActions {
    static FETCH_ALL_DISTRIBUTOR_OUTLETS_START =
        'FETCH_ALL_DISTRIBUTOR_OUTLETS_START';
    static FETCH_ALL_DISTRIBUTOR_OUTLETS_SUCCESS =
        'FETCH_ALL_DISTRIBUTOR_OUTLETS_SUCCESS';
    static FETCH_ALL_DISTRIBUTOR_OUTLETS_FAILURE =
        'FETCH_ALL_DISTRIBUTOR_OUTLETS_FAILURE';
    static FETCH_ALL_NON_DISTRIBUTOR_OUTLETS_START =
        'FETCH_ALL_NON_DISTRIBUTOR_OUTLETS_START';
    static FETCH_ALL_NON_DISTRIBUTOR_OUTLETS_SUCCESS =
        'FETCH_ALL_NON_DISTRIBUTOR_OUTLETS_SUCCESS';
    static FETCH_ALL_NON_DISTRIBUTOR_OUTLETS_FAILURE =
        'FETCH_ALL_NON_DISTRIBUTOR_OUTLETS_FAILURE';
    static CREATE_ZONE_MAP_START = 'CREATE_ZONE_MAP_START';
    static CREATE_ZONE_MAP_SUCCESS = 'CREATE_ZONE_MAP_SUCCESS';
    static CREATE_ZONE_MAP_FAILURE = 'CREATE_ZONE_MAP_FAILURE';
    static FETCH_TEAM_HOMEBASE_START = 'FETCH_TEAM_HOMEBASE_START';
    static FETCH_TEAM_HOMEBASE_SUCCESS = 'FETCH_TEAM_HOMEBASE_SUCCESS';
    static FETCH_TEAM_HOMEBASE_FAILURE = 'FETCH_TEAM_HOMEBASE_FAILURE';
    static SORT_OUTLET_START = 'SORT_OUTLET_START';
    static SORT_OUTLET_SUCCESS = 'SORT_OUTLET_SUCCESS';
    static SORT_OUTLET_FAILURE = 'SORT_OUTLET_FAILURE';
    static UPDATE_OUTLET_START = 'UPDATE_OUTLET_START';
    static UPDATE_OUTLET_SUCCESS = 'UPDATE_OUTLET_SUCCESS';
    static UPDATE_OUTLET_FAILURE = 'UPDATE_OUTLET_FAILURE';
    static UNASSIGN_OUTLET_START = 'UNASSIGN_OUTLET_START';
    static UNASSIGN_OUTLET_SUCCESS = 'UNASSIGN_OUTLET_SUCCESS';
    static UNASSIGN_OUTLET_FAILURE = 'UNASSIGN_OUTLET_FAILURE';

    static fetchDistributorOutletsStart() {
        return {
            type: TerritoryPlanningActions.FETCH_ALL_DISTRIBUTOR_OUTLETS_START
        };
    }

    static fetchNonDistributorOutletsStart() {
        return {
            type:
                TerritoryPlanningActions.FETCH_ALL_NON_DISTRIBUTOR_OUTLETS_START
        };
    }

    static fetchDistributorOutletSuccess(response: TerritoryOutlets) {
        return {
            type:
                TerritoryPlanningActions.FETCH_ALL_DISTRIBUTOR_OUTLETS_SUCCESS,
            outlet: response.outlets
        };
    }

    static fetchNonDistributorOutletSuccess(response: TerritoryOutlets) {
        return {
            type:
                TerritoryPlanningActions.FETCH_ALL_NON_DISTRIBUTOR_OUTLETS_SUCCESS,
            outlet: response.outlets
        };
    }

    static fetchDistributorOutletFailure(error: Error) {
        return {
            type:
                TerritoryPlanningActions.FETCH_ALL_DISTRIBUTOR_OUTLETS_FAILURE,
            error
        };
    }

    static fetchNonDistributorOutletFailure(error: Error) {
        return {
            type:
                TerritoryPlanningActions.FETCH_ALL_NON_DISTRIBUTOR_OUTLETS_FAILURE,
            error
        };
    }

    static createZoneMapStart() {
        return {
            type: TerritoryPlanningActions.CREATE_ZONE_MAP_START
        };
    }

    static createZoneMapSuccess(zone: ZoneMap) {
        return {
            type: TerritoryPlanningActions.CREATE_ZONE_MAP_SUCCESS,
            zone
        };
    }

    static createZoneMapFailure(zone: ZoneMap, error: Error) {
        return {
            type: TerritoryPlanningActions.CREATE_ZONE_MAP_FAILURE,
            error,
            zone
        };
    }
    static fetchTeamHomebaseStart() {
        return {
            type: TerritoryPlanningActions.FETCH_TEAM_HOMEBASE_START
        };
    }

    static fetchTeamHomebaseSuccess(homebases: Array<MasterHomebase>) {
        return {
            type: TerritoryPlanningActions.FETCH_TEAM_HOMEBASE_SUCCESS,
            homebases
        };
    }

    static fetchTeamHomebaseFailure(error: Error) {
        return {
            type: TerritoryPlanningActions.CREATE_ZONE_MAP_FAILURE,
            error
        };
    }

    static sortOutletStart() {
        return {
            type: TerritoryPlanningActions.SORT_OUTLET_START
        };
    }
    static sortOutletSuccess(outlet: MasterOutlet, sortedRoute: Object) {
        return {
            type: TerritoryPlanningActions.SORT_OUTLET_SUCCESS,
            sortedRoute,
            outlet
        };
    }

    static sortOutletFailure(outlet: MasterOutlet, error: Error) {
        return {
            type: TerritoryPlanningActions.SORT_OUTLET_SUCCESS,
            outlet,
            error
        };
    }

    static updateOutletStart() {
        return {
            type: TerritoryPlanningActions.UPDATE_OUTLET_START
        };
    }

    static updateOutletSuccess() {
        return {
            type: TerritoryPlanningActions.UPDATE_OUTLET_SUCCESS
        };
    }

    static updateOutletError() {
        return {
            type: TerritoryPlanningActions.UPDATE_OUTLET_FAILURE
        };
    }
    static unassignOutletStart() {
        return {
            type: TerritoryPlanningActions.UNASSIGN_OUTLET_START
        };
    }

    static unassignOutletSuccess() {
        return {
            type: TerritoryPlanningActions.UNASSIGN_OUTLET_SUCCESS
        };
    }

    static unassignOutletError() {
        return {
            type: TerritoryPlanningActions.UNASSIGN_OUTLET_FAILURE
        };
    }

    static fetchDistributorOutlets(
        clientId: string,
        distributorFilters: FilterListBuilder
    ) {
        return (dispatch: Dispatch<*>) => {
            dispatch(TerritoryPlanningActions.fetchDistributorOutletsStart());
            return new Promise((resolve, reject) => {
                const apiParams = {
                    clientId
                };
                //  hardcoding the size to upper limit of outlet master for now
                //  to be fixed
                const body = {
                    filters: distributorFilters,
                    page: 1,
                    size: 6000
                };
                bulkOutletFetch
                    .post(apiParams, body)
                    .then(response => {
                        resolve(response);
                        dispatch(
                            TerritoryPlanningActions.fetchDistributorOutletSuccess(
                                response
                            )
                        );
                    })
                    .catch(error => {
                        dispatch(
                            TerritoryPlanningActions.fetchDistributorOutletFailure(
                                error
                            )
                        );
                        const toast = {
                            message: error.message,
                            type: ToastTypes.Error
                        };
                        reject(error);
                        dispatch(showToast(toast));
                    });
            });
        };
    }

    static fetchNonDistributorOutlets(
        clientId: string,
        distributorFilters: FilterListBuilder,
        page: number,
        pageSize: number
    ) {
        return (dispatch: Dispatch<*>) => {
            dispatch(
                TerritoryPlanningActions.fetchNonDistributorOutletsStart()
            );
            return new Promise((resolve, reject) => {
                const apiParams = {
                    clientId
                };
                const body = {
                    filters: distributorFilters,
                    page,
                    size: pageSize
                };
                bulkOutletFetch
                    .post(apiParams, body)
                    .then(response => {
                        resolve(response);
                        dispatch(
                            TerritoryPlanningActions.fetchNonDistributorOutletSuccess(
                                response
                            )
                        );
                    })
                    .catch(error => {
                        dispatch(
                            TerritoryPlanningActions.fetchNonDistributorOutletFailure(
                                error
                            )
                        );
                        const toast = {
                            message: error.message,
                            type: ToastTypes.Error
                        };
                        dispatch(showToast(toast));
                        reject(error);
                    });
            });
        };
    }

    static createZoneMap(clientId: string, zoneMap: ZoneMap) {
        return (dispatch: Dispatch<*>) => {
            dispatch(TerritoryPlanningActions.createZoneMapStart());
            return new Promise((resolve, reject) => {
                const apiParams = {
                    clientId
                };
                const body = zoneMap;
                zoneMapCreateApi
                    .post(apiParams, body)
                    .then(response => {
                        dispatch(
                            TerritoryPlanningActions.createZoneMapSuccess(
                                response
                            )
                        );
                        resolve(response);
                    })
                    .catch(error => {
                        dispatch(
                            TerritoryPlanningActions.createZoneMapFailure(
                                zoneMap,
                                error
                            )
                        );
                        const toast = {
                            message: error.message,
                            type: ToastTypes.Error
                        };
                        dispatch(showToast(toast));
                        reject(error);
                    });
            });
        };
    }

    static fetchTeamHomebases(clientId: string, teamId: string) {
        return (dispatch: Dispatch<*>) => {
            dispatch(TerritoryPlanningActions.fetchTeamHomebaseStart());
            return new Promise((resolve, reject) => {
                homebaseApi
                    .fetch({ clientId, team: teamId })
                    .then(response => {
                        dispatch(
                            TerritoryPlanningActions.fetchTeamHomebaseSuccess(
                                response
                            )
                        );
                        resolve(response);
                    })
                    .catch(error => {
                        dispatch(
                            TerritoryPlanningActions.fetchTeamHomebaseFailure(
                                error
                            )
                        );
                        const toast = {
                            message: error.message,
                            type: ToastTypes.Error
                        };
                        dispatch(showToast(toast));
                        reject(error);
                    });
            });
        };
    }

    static sortOutlet(clientId: string, outletId: string, homebaseId: string) {
        return (dispatch: Dispatch<*>) => {
            dispatch(TerritoryPlanningActions.sortOutletStart());
            const body = { outletId, homebaseId };
            return new Promise((resolve, reject) => {
                outletAutosortApi
                    .post({ clientId }, body)
                    .then(response => {
                        dispatch(
                            TerritoryPlanningActions.sortOutletSuccess(
                                body,
                                response
                            )
                        );
                        resolve(response);
                    })
                    .catch(error => {
                        dispatch(
                            TerritoryPlanningActions.sortOutletSuccess(
                                body,
                                error
                            )
                        );
                        const toast = {
                            message: error.message,
                            type: ToastTypes.Error
                        };
                        dispatch(showToast(toast));
                        reject(error);
                    });
            });
        };
    }
}
